// Core packages

// Third party packages

// Custom packages

/**
 * Builds the `propertyStatus` body of PATCH properties/:id from the model of the
 * "Stato" panel of the property pages, without ever touching the model itself.
 *
 * GET properties/:id returns `mappingCompleted.user` populated
 * ({ _id, firstName, lastName }) and the pages add a display-only
 * `mappingCompleted.username` next to it. The back-end expects the user id and
 * rewrites `propertyStatus` as a whole, so the conversion must run on a copy:
 * converting the live model in place turned `user` into a string, and the next
 * save without a reload read `"<id>"._id`, sent no user at all and wiped the
 * mapper from the DB.
 *
 * The copy goes through the same JSON serialization HttpClient applies to the
 * body, so the request is the one the pages already sent on the first save
 * (Date and moment values become ISO strings, undefined keys are dropped).
 *
 * @since 3.0.0
 *
 * @param propertyStatus `modelSP.propertyStatus` of the page; null and undefined are returned as they are
 * @returns a new object, safe to send; the input is left untouched
 */
export function buildPropertyStatusPayload(propertyStatus: any): any {
  if (propertyStatus === null || propertyStatus === undefined) {
    return propertyStatus;
  }

  const payload: any = JSON.parse(JSON.stringify(propertyStatus));
  const mappingCompleted: any = payload.mappingCompleted;

  if (mappingCompleted && typeof mappingCompleted === "object") {
    // Display-only label built by the pages from the populated user
    delete mappingCompleted.username;

    // Populated user -> id. A string is already an id; null, undefined or an
    // object without _id are sent as they are and left to the back-end
    // validation: dropping the key would silently erase the mapper.
    const user: any = mappingCompleted.user;
    if (user && typeof user === "object" && user._id) {
      mappingCompleted.user = user._id;
    }
  }

  return payload;
}
